import { ApplicationConfigWithPages } from '../../../shared/features/ng-redux/app/appConfig.models';

import {
  CHART_UI_DONUT_TOPN,
  DEFAULT_DEVICE_FILTER_BAR_CONFIG,
  DEVICE_APP_USAGE,
  DEVICE_BATTERY_USAGE_W,
  DEVICE_DATA_USAGE,
  DEVICE_LAST_KNOWN,
  DEVICE_SIGNAL_STRENGTH,
  LAST_KNOWN_PAGE_W,
  SIGNAL_STRENGTH_PAGE_W,
  SMART_BATTERY_SPOTLIGHT,
  DEVICE_SUMMARY_CHART_ITEMS,
  DEVICE_WIFI,
  CHART_UI_DONUT_LEAST_MOST,
  DEVICE_DATA_USAGE_W,
  DEVICE_SIGNAL_STRENGTH_W,
} from './app-mapper.constants';
import { InsSelectionType, TableRenderEnum } from '@nx-fe/table';

import {
  BarChartConfig,
  ChartTypeEnum,
  DonutChartConfig,
  ElementTypeEnum,
  LineChartConfig,
  MapDashboardElement,
  MostLeastEnum,
  SummaryChartConfig,
  TableConfig,
} from 'shared/models/chart.models';
import { HighchartsConstant } from '../../../../../../xs-colors';
import { PageCategory } from '../../../shared/features/ng-redux/page/page.models';
import { buildChartOptions, findPageId, patchChart, patchPage } from './app-mapper.utils';
import { CONSTANTS } from '../../../shared/localizations/dictionary';
import { ProfilePermissionEnum } from '../../../../../../../libs/services';

export function mapLastKnownWindowsConfig(
  app: ApplicationConfigWithPages,
  devApp: ApplicationConfigWithPages,
  devAppWin: ApplicationConfigWithPages
): ApplicationConfigWithPages {
  app.dashboardType = CONSTANTS.DASHBOARD_TYPES.DEVICE;
  app.claims = [ProfilePermissionEnum.ProfileViewLastLocationDashboard];
  patchPage(app, LAST_KNOWN_PAGE_W, page => {
    page.filterBarVisible = true;
    page.filterBarConfig = DEFAULT_DEVICE_FILTER_BAR_CONFIG;
    app.name = 'Device_Filter_Last_Location';
    page.pageCategory = PageCategory.DEVICE;
    page.predefinedCharts = [
      {
        category: {
          // 1
          name: 'Device_Charts_Category_Name_Caption',
          icon: 'insight-icon-device',
          tooltip: 'Device_Charts_Category_Name_Tooltip_Caption',
        },
        charts: [
          buildChartOptions(
            page.charts,
            'lklManufacturers_w',
            'Device_Charts_Category_Chart_Caption_Top_Manufacturers'
          ),
          buildChartOptions(page.charts, 'lklModel_w', 'Device_Charts_Category_Chart_Caption_Top_Models'),
          buildChartOptions(page.charts, 'lklOSVersion_w', 'Device_Charts_Category_Chart_Caption_Top_OS_Versions'),
        ],
      },
      {
        category: {
          // 11
          name: 'Data_Usage_Charts_Category_Header_Network',
          icon: '',
          tooltip: 'Data_Usage_Charts_Category_Header_Network_Tooltip',
        },
        charts: [
          buildChartOptions(page.charts, 'lklNetworkType_w', 'Data_Usage_Charts_Category_Connection_Type'),
          buildChartOptions(page.charts, 'lklCarrier_w', 'Last_Location_Charts_Category_Mobile_Carriers'),
          buildChartOptions(
            page.charts,
            'lklSignalStrength_w',
            'Last_Location_Charts_Category_Carrier_Signal_Strength'
          ),
          buildChartOptions(page.charts, 'lklMap_w', 'Last_Location_Charts_Category_Map'),
        ],
      },
    ];

    patchChart(page.charts, 'lklDevSummary_w', (chart: SummaryChartConfig) => {
      chart.elementType = ElementTypeEnum.SUMMARY;
      chart.name = 'devices_summary_name';
      chart.fullName = undefined;
      chart.layout = '33p';
      chart.fullName = 'devices_summary_full_name_dashboards';
      chart.items = DEVICE_SUMMARY_CHART_ITEMS;
    });

    patchChart(page.charts, 'lklManufacturers_w', (chart: DonutChartConfig) => {
      chart.fullName = 'Manufacturers_fullName';
      chart.reportSummary = 'Manufacturers_reportsummary';
      chart.name = 'lkl_chart_manufacturers_name';
      chart.type = ChartTypeEnum.DONUT;
      chart.elementType = 'chart';
      chart.layout = '33p';
      chart.tag = {
        name: 'lkl_chart_manufacturers_name',
        parameters: ['topN', 'mostLeast'],
      };
      chart.tooltip = {
        label: "`${xsI18nPipe.transform('lkl_chart_manufacturer_tooltip_label', this.point.name)}`",
        labelArgs: ['lkl_chart_manufacturer_tooltip_label', 'this.point.name'],
        value:
          "`${xsI18nPipe.transform('lkl_chart_manufacturer_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'lkl_chart_manufacturer_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
      chart.filter = {
        attribute: 'filter',
        type: 'mapped',
      };
      chart.filters = {
        topN: 5,
        mostLeast: MostLeastEnum.MOST,
      };
      chart.uiSettings = [CHART_UI_DONUT_TOPN, CHART_UI_DONUT_LEAST_MOST];
    });
    patchChart(page.charts, 'lklModel_w', (chart: DonutChartConfig) => {
      chart.fullName = 'Model_fullName';
      chart.reportSummary = 'Model_reportsummary';
      chart.name = 'lkl_chart_models_name';
      chart.type = ChartTypeEnum.DONUT;
      chart.elementType = 'chart';
      chart.layout = '33p';
      chart.tag = {
        name: 'lkl_chart_models_name',
        parameters: ['topN', 'mostLeast'],
      };
      chart.tooltip = {
        label: "`${xsI18nPipe.transform('lkl_chart_models_tooltip_label', this.point.name)}`",
        labelArgs: ['lkl_chart_models_tooltip_label', 'this.point.name'],
        value:
          "`${xsI18nPipe.transform('lkl_chart_models_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'lkl_chart_models_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
      chart.filter = {
        attribute: 'filter',
        type: 'mapped',
      };
      chart.filters = {
        topN: 5,
        mostLeast: MostLeastEnum.MOST,
      };
      chart.uiSettings = [CHART_UI_DONUT_TOPN, CHART_UI_DONUT_LEAST_MOST];
    });
    patchChart(page.charts, 'lklOSVersion_w', (chart: BarChartConfig) => {
      chart.fullName = 'OSVersion_fullName';
      chart.reportSummary = 'OSVersion_reportsummary';
      chart.name = 'lkl_chart_os_versions_name';
      chart.layout = '33p';
      chart.type = ChartTypeEnum.COLUMN;
      chart.elementType = 'chart';
      chart.dimension = {
        dimensionId: 'name',
        label: 'windows_ver_label',
        noDataLabel: 'no_data_label',
      };
      chart.metric = {
        metricId: 'metric',
        label: 'device_count_label',
      };
      chart.filters = {
        topN: 5,
        mostLeast: MostLeastEnum.MOST,
      };
      chart.tag = {
        name: 'lkl_chart_os_versions_name',
        parameters: ['topN', 'mostLeast'],
      };
      chart.colorByPoint = true;
      chart.integerOnly = true;
      chart.tooltip = {
        label: "`${xsI18nPipe.transform('lkl_chart_os_version_tooltip_label', this.point.name)}`",
        labelArgs: ['lkl_chart_os_version_tooltip_label', 'this.point.name'],
        value:
          "`${xsI18nPipe.transform('lkl_chart_os_version_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'lkl_chart_os_version_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
      chart.uiSettings = [CHART_UI_DONUT_TOPN, CHART_UI_DONUT_LEAST_MOST];
    });
    patchChart(page.charts, 'lklNetworkType_w', (chart: BarChartConfig) => {
      chart.reportSummary = 'lkl_chart_network_type_reportsummary';
      chart.fullName = 'lkl_chart_network_type_fullname';
      chart.name = 'lkl_chart_network_type_name';
      chart.layout = '33p';
      chart.type = ChartTypeEnum.COLUMN;
      chart.elementType = 'chart';
      chart.dimension = {
        dimensionId: 'name',
        label: 'lkl_chart_network_dimension_label',
        noDataLabel: 'no_data_label',
      };
      chart.metric = {
        metricId: 'metric',
        label: 'device_count_label',
      };
      chart.tag = {
        name: 'lkl_chart_network_type_name',
      };
      chart.integerOnly = true;
      chart.tooltip = {
        label:
          "`${xsI18nPipe.transform('lkl_chart_network_type_tooltip_label', `${xsI18nPipe.transform(this.point.name)}`)}`",
        labelArgs: ['lkl_chart_network_type_tooltip_label', 'xsI18nPipe.transform(this.point.name)'],
        value:
          "`${xsI18nPipe.transform('lkl_chart_network_type_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'lkl_chart_network_type_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
    });
    patchChart(page.charts, 'lklCarrier_w', (chart: DonutChartConfig) => {
      chart.tag = {
        name: 'Last_Location_Charts_Category_Mobile_Carriers',
      };
      chart.fullName = 'lkl_chart_carrier_fullname';
      chart.reportSummary = 'lkl_chart_carrier_reportsummary';
      chart.name = 'lkl_chart_carrier_name';
      chart.type = ChartTypeEnum.DONUT;
      chart.elementType = 'chart';
      chart.layout = '33p';
      chart.tooltip = {
        label: "`${xsI18nPipe.transform('lkl__chart_carrier_tooltip_label', this.point.name)}`",
        labelArgs: ['lkl__chart_carrier_tooltip_label', 'this.point.name'],
        value:
          "`${xsI18nPipe.transform('lkl__chart_carrier_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'lkl__chart_carrier_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
      chart.filter = {
        attribute: 'filter',
        type: 'mapped',
      };
    });
    patchChart(page.charts, 'lklMap_w', (map: MapDashboardElement) => {
      map.cardStyle = ['bottomStatic', 'static'];
    });

    patchChart(page.charts, 'lklTable_w', (chart: TableConfig) => {
      chart.name = 'Ticket_List_Devices_Header';
      chart.selectionType = InsSelectionType.multiple;
      chart.selectionText = 'device_selected_label';
      chart.selectionTextPlural = 'device_selected_label';
      chart.rowActions = [
        {
          action: 'customAttributes',
          tooltip: 'custom_attr_title',
          icon: 'insight-icon-deviceinfo',
        },
      ];
      chart.tableAttributes = [
        {
          id: 'McDeviceName',
          label: 'Column_Name_Device_Name',
          renderer: TableRenderEnum.LINK,
          iconClass: 'insight-icon-type-DeviceWindowsDesktop',
          rendererParams: {
            eventId: 'deviceClicked',
            icons: [
              {
                iconClass: 'insight-icon-type-DeviceWindowsDesktop',
              },
            ],
          },
        },
        {
          id: 'McDeviceId',
          label: 'Column_Name_Device_Id',
          renderer: TableRenderEnum.STRING,
        },
        {
          id: 'Name',
          label: 'Column_Name_Device_Group',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
        {
          id: 'McDevicePath',
          label: 'group_path_label',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
        {
          id: 'manufacturer',
          label: 'label_Manufacturer',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
        {
          id: 'model',
          label: 'Column_Name_Model',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
        {
          id: 'osVersion',
          label: 'Column_Name_Os_Version',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
        {
          id: 'carrier',
          label: 'networkcarrier_label',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
      ];
    });
    patchChart(page.charts, 'lklSignalStrength_w', (chart: DonutChartConfig) => {
      chart.fullName = 'lkl_chart_signal_strength_fullname';
      chart.reportSummary = 'lkl_chart_signal_strength_reportsummary';
      chart.name = 'lkl_chart_signal_strength_name';
      chart.type = ChartTypeEnum.DONUT;
      chart.elementType = 'chart';
      chart.layout = '33p';
      chart.tag = {
        name: 'Last_Location_Charts_Category_Carrier_Signal_Strength',
      };
      chart.filter = {
        attribute: 'filter',
        type: 'mapped',
      };
      chart.fixedColors = [
        {
          label: '{SignalStrength_0}',
          color: HighchartsConstant.signalStrengthBucket.nosignal,
        },
        {
          label: '{SignalStrength_3}',
          color: HighchartsConstant.signalStrengthBucket.bad,
        },
        {
          label: '{SignalStrength_2}',
          color: HighchartsConstant.signalStrengthBucket.average,
        },
        {
          label: '{SignalStrength_1}',
          color: HighchartsConstant.signalStrengthBucket.good,
        },
      ];
      chart.uiSettings = [
        {
          id: 'SignalStrengthBar',
          controlType: 'THRESHOLD',
          type: 'number',
          displayType: 'dropdown',
          name: 'select_signal_strength_bar',
          options: [],
        },
      ];

      chart.tooltip = {
        label: "`${xsI18nPipe.transform('lkl_chart_signal_strength_tooltip_label', this.point.name)}`",
        labelArgs: ['lkl_chart_signal_strength_tooltip_label', 'this.point.name'],
        value:
          "`${xsI18nPipe.transform('lkl_chart_signal_strength_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'lkl_chart_signal_strength_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
    });
  });

  const pageIds = [
    findPageId(app.pages, LAST_KNOWN_PAGE_W),
    // findPageId(devApp.pages, DEVICE_SUMMARY),
  ];

  const childPageIds = [
    findPageId(devAppWin.pages, DEVICE_BATTERY_USAGE_W),
    findPageId(devApp.pages, DEVICE_APP_USAGE),
    findPageId(devAppWin.pages, DEVICE_DATA_USAGE_W),
    findPageId(devApp.pages, DEVICE_LAST_KNOWN),
    findPageId(devAppWin.pages, DEVICE_SIGNAL_STRENGTH_W),
    findPageId(devApp.pages, SMART_BATTERY_SPOTLIGHT),
    findPageId(devApp.pages, DEVICE_WIFI),
  ];

  const defaultTabId = findPageId(devApp.pages, DEVICE_LAST_KNOWN);

  return { ...app, pageIds, childPageIds, defaultTabId };
}

export function mapSignalStrengthWindowsConfig(
  app: ApplicationConfigWithPages,
  devApp: ApplicationConfigWithPages,
  devAppWin: ApplicationConfigWithPages
): ApplicationConfigWithPages {
  app.dashboardType = CONSTANTS.DASHBOARD_TYPES.DEVICE;
  app.claims = [ProfilePermissionEnum.ProfileViewSignalStrengthDashboard];
  patchPage(app, SIGNAL_STRENGTH_PAGE_W, page => {
    page.filterBarVisible = true;
    page.filterBarConfig = DEFAULT_DEVICE_FILTER_BAR_CONFIG;
    page.hourEnabled = true;
    page.multiHourSelector = true;
    app.group = 'device_filter_network_group';
    app.name = 'Device_Filter_Signal_Strength';
    page.pageCategory = PageCategory.DEVICE;
    page.predefinedCharts = [
      {
        category: {
          // 1
          name: 'Device_Charts_Category_Name_Caption',
          icon: 'insight-icon-device',
          tooltip: 'Device_Charts_Category_Name_Tooltip_Caption',
        },
        charts: [
          buildChartOptions(page.charts, 'ssManufacturers_w', 'Device_Charts_Category_Chart_Caption_Top_Manufacturers'),
          buildChartOptions(page.charts, 'ssModel_w', 'Device_Charts_Category_Chart_Caption_Top_Models'),
          buildChartOptions(page.charts, 'ssOSVersion_w', 'Device_Charts_Category_Chart_Caption_Top_OS_Versions'),
        ],
      },
      {
        category: {
          // 11
          name: 'Data_Usage_Charts_Category_Header_Network',
          icon: '',
          tooltip: 'Data_Usage_Charts_Category_Header_Network_Tooltip',
        },
        charts: [
          buildChartOptions(page.charts, 'ssNetworkType_w', 'Data_Usage_Charts_Category_Connection_Type'),
          buildChartOptions(page.charts, 'ssCarrier_w', 'Last_Location_Charts_Category_Mobile_Carriers'),
          buildChartOptions(page.charts, 'ssSignalStrength_w', 'Last_Location_Charts_Category_Carrier_Signal_Strength'),
          buildChartOptions(page.charts, 'ssNetworkTypeTS_w', 'Last_Location_Charts_Category_Network_Type'),
          buildChartOptions(page.charts, 'ssSignalDrop_w', 'Last_Location_Charts_Category_Total_Signal_Dropouts'),
          buildChartOptions(
            page.charts,
            'ssSignalStrengthTS_w',
            'Last_Location_Charts_Category_Average_Signal_Strength'
          ),
          buildChartOptions(page.charts, 'ssHeatmap_w', 'Last_Location_Charts_Category_Map'),
        ],
      },
    ];

    patchChart(page.charts, 'ssDevSummary_w', (chart: SummaryChartConfig) => {
      chart.elementType = ElementTypeEnum.SUMMARY;
      chart.name = 'devices_summary_name';
      chart.fullName = undefined;
      chart.layout = '33p';
      chart.fullName = 'devices_summary_full_name_dashboards';
      chart.items = DEVICE_SUMMARY_CHART_ITEMS;
    });

    patchChart(page.charts, 'ssHeatmap_w', (map: MapDashboardElement) => {
      map.cardStyle = ['bottomStatic', 'static'];
    });

    patchChart(page.charts, 'ssManufacturers_w', (chart: DonutChartConfig) => {
      chart.fullName = 'Manufacturers_fullName';
      chart.reportSummary = 'Manufacturers_reportsummary';
      chart.name = 'ss_chart_manufacturers_name';
      chart.type = ChartTypeEnum.DONUT;
      chart.elementType = 'chart';
      chart.layout = '33p';
      chart.tag = {
        name: 'ss_chart_manufacturers_name',
        parameters: ['topN', 'mostLeast'],
      };
      chart.filters = {
        topN: 5,
        mostLeast: MostLeastEnum.MOST,
      };
      chart.tooltip = {
        label: "`${xsI18nPipe.transform('ss_chart_manufacturer_tooltip_label', this.point.name)}`",
        labelArgs: ['ss_chart_manufacturer_tooltip_label', 'this.point.name'],
        value:
          "`${xsI18nPipe.transform('ss_chart_manufacturer_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'ss_chart_manufacturer_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
      chart.filter = {
        attribute: 'filter',
        type: 'mapped',
      };
      chart.uiSettings = [CHART_UI_DONUT_TOPN, CHART_UI_DONUT_LEAST_MOST];
    });
    patchChart(page.charts, 'ssModel_w', (chart: DonutChartConfig) => {
      chart.fullName = 'Model_fullName';
      chart.reportSummary = 'Model_reportsummary';
      chart.name = 'ss_chart_models_name';
      chart.type = ChartTypeEnum.DONUT;
      chart.elementType = 'chart';
      chart.layout = '33p';
      chart.tag = {
        name: 'ss_chart_models_name',
        parameters: ['topN', 'mostLeast'],
      };
      chart.tooltip = {
        label: "`${xsI18nPipe.transform('ss_chart_models_tooltip_label', this.point.name)}`",
        labelArgs: ['ss_chart_models_tooltip_label', 'this.point.name'],
        value:
          "`${xsI18nPipe.transform('ss_chart_models_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'ss_chart_models_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
      chart.filter = {
        attribute: 'filter',
        type: 'mapped',
      };
      chart.filters = {
        topN: 5,
        mostLeast: MostLeastEnum.MOST,
      };
      chart.uiSettings = [CHART_UI_DONUT_TOPN, CHART_UI_DONUT_LEAST_MOST];
    });
    patchChart(page.charts, 'ssOSVersion_w', (chart: BarChartConfig) => {
      chart.fullName = 'OSVersion_fullName';
      chart.reportSummary = 'OSVersion_reportsummary';
      chart.name = 'ss_chart_os_versions_name';
      chart.layout = '33p';
      chart.type = ChartTypeEnum.COLUMN;
      chart.elementType = 'chart';

      chart.dimension = {
        dimensionId: 'name',
        label: 'windows_ver_label',
        noDataLabel: 'no_data_label',
      };
      chart.metric = {
        metricId: 'metric',
        label: 'device_count_label',
      };
      chart.tag = {
        name: 'ss_chart_os_versions_name',
        parameters: ['topN', 'mostLeast'],
      };
      chart.filters = {
        topN: 5,
        mostLeast: MostLeastEnum.MOST,
      };
      chart.colorByPoint = true;
      chart.integerOnly = true;
      chart.tooltip = {
        label: "`${xsI18nPipe.transform('ss_chart_os_version_tooltip_label', this.point.name)}`",
        labelArgs: ['ss_chart_os_version_tooltip_label', 'this.point.name'],
        value:
          "`${xsI18nPipe.transform('ss_chart_os_version_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'ss_chart_os_version_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
      chart.uiSettings = [CHART_UI_DONUT_TOPN, CHART_UI_DONUT_LEAST_MOST];
    });
    patchChart(page.charts, 'ssCarrier_w', (chart: DonutChartConfig) => {
      chart.tag = {
        name: 'Last_Location_Charts_Category_Mobile_Carriers',
      };
      chart.name = 'ss_chart_carrier_name';
      chart.fullName = 'ss_chart_carrier_fullname';
      chart.reportSummary = 'ss_chart_carrier_reportsummary';
      chart.type = ChartTypeEnum.DONUT;
      chart.elementType = 'chart';
      chart.layout = '33p';
      chart.tooltip = {
        label: "`${xsI18nPipe.transform('ss_chart_carrier_tooltip_label', this.point.name)}`",
        labelArgs: ['ss_chart_carrier_tooltip_label', 'this.point.name'],
        value:
          "`${xsI18nPipe.transform('ss_chart_carrier_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'ss_chart_carrier_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
      chart.filter = {
        attribute: 'filter',
        type: 'mapped',
      };
    });

    patchChart(page.charts, 'ssNetworkType_w', (chart: BarChartConfig) => {
      chart.name = 'ss_chart_network_type_name';
      chart.reportSummary = 'ss_chart_network_type_reportsummary';
      chart.fullName = 'ss_chart_network_type_fullname';
      chart.type = ChartTypeEnum.COLUMN;
      chart.layout = '33p';
      chart.elementType = 'chart';

      chart.dimension = {
        dimensionId: 'name',
        label: 'ss_chart_network_dimension_label',
        noDataLabel: 'no_data_label',
      };
      chart.metric = {
        metricId: 'y',
        label: 'device_count_label',
      };
      chart.tag = {
        name: 'ss_chart_network_type_name',
      };
      chart.integerOnly = true;
      chart.tooltip = {
        label:
          "`${xsI18nPipe.transform('ss_chart_network_type_tooltip_label', xsI18nPipe.transform(this.point.name))}`",
        labelArgs: ['ss_chart_network_type_tooltip_label', 'xsI18nPipe.transform(this.point.name)'],
        value:
          "`${xsI18nPipe.transform('ss_chart_network_type_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'ss_chart_network_type_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
    });

    patchChart(page.charts, 'ssSignalStrength_w', (chart: DonutChartConfig) => {
      chart.fullName =
        'This chart shows device(s) categorized by carrier signal strength.\n\n' +
        '• Bad - Less than or equal to lower threshold\n(1 bar by default)\n' +
        '• Average - Between lower and upper thresholds\n(2 bars by default)' +
        '• Good - Greater than or equal to  upper threshold\n (3 & 4 bars by default)\n';
      chart.tag = {
        name: 'Last_Location_Charts_Category_Carrier_Signal_Strength',
      };
      chart.type = ChartTypeEnum.DONUT;
      chart.elementType = 'chart';
      chart.layout = '33p';
      chart.name = 'ss_chart_signal_strength_dimension_label';
      chart.fullName = 'ss_chart_signal_strength_fullname';
      chart.reportSummary = 'ss_chart_signal_strength_reportsummary';
      chart.filter = {
        attribute: 'filter',
        type: 'mapped',
      };

      chart.uiSettings = [
        {
          id: 'SignalStrengthBar',
          controlType: 'THRESHOLD',
          type: 'number',
          displayType: 'dropdown',
          name: 'select_signal_strength_bar',
          options: [],
        },
      ];
      chart.tooltip = {
        label: "`${xsI18nPipe.transform('ss_chart_signal_strength_tooltip_label', this.point.name)}`",
        labelArgs: ['ss_chart_signal_strength_tooltip_label', 'this.point.name'],
        value:
          "`${xsI18nPipe.transform('ss_chart_signal_strength_tooltip_value', this.point.y,  (this.point.y/this.point.devcount*100).toFixed(2).replace(/\\.?0+$/,''), this.point.devcount)}`",
        valueArgs: [
          'ss_chart_signal_strength_tooltip_value',
          'this.point.y',
          'percentage(this.point.y, this.point.devcount)',
          'this.point.devcount',
        ],
      };
    });

    patchChart(page.charts, 'ssNetworkTypeTS_w', (chart: LineChartConfig) => {
      chart.fullName = 'ss_network_type_usage_fullname';
      chart.name = 'ss_network_type_usage_name';
      chart.type = ChartTypeEnum.LINE;
      chart.elementType = 'chart';
      chart.layout = '66p';
      chart.dimension = {
        dimensionId: 'x',
        label: 'xs_time_interval_label',
        noDataLabel: 'no_data_label',
      };
      chart.metric = {
        metricId: undefined,
        label: 'ss_network_type_usage_metric_label',
      };
      chart.metrics = [
        {
          id: 'nt_1',
        },
        {
          id: 'nt_2',
        },
        {
          id: 'nt_3',
        },
        {
          id: 'nt_4',
        },
        {
          id: 'nt_5',
        },
        {
          id: 'nt_6',
        },
        {
          id: 'nt_100',
        },
      ];
      chart.tag = {
        name: 'ss_network_type_usage_name',
      };

      chart.tooltip = {
        label: 'xs_reported_date_label',
        value: 'ss_network_type_usage_tooltip_value',
      };

      chart.legends = [
        'ss_network_type_usage_metric_label_lte',
        'ss_network_type_usage_metric_label_2g',
        'ss_network_type_usage_metric_label_3g',
        'ss_network_type_usage_metric_label_4g',
        'ss_network_type_usage_metric_label_5g',
        'ss_network_type_usage_metric_label_iwlan',
        'ss_network_type_usage_metric_label_unknown',
      ];
      chart.integerOnly = true;
      chart.formatDate = true;
      chart.legendDisabled = false;
      chart.dateFormatStr = 'LL';
      chart.hourSwitch = true;
    });

    patchChart(page.charts, 'ssSignalDrop_w', (chart: LineChartConfig) => {
      chart.fullName = 'ss_total_signal_dropout_fullname';
      chart.name = 'ss_total_signal_dropout_name';
      chart.type = ChartTypeEnum.LINE;
      chart.elementType = 'chart';
      chart.layout = '100p';
      chart.dimension = {
        dimensionId: 'x',
        label: 'xs_time_interval_label',
        noDataLabel: 'no_data_label',
      };
      chart.metric = {
        metricId: 'do',
        label: 'ss_total_signal_dropout_metric_label',
      };
      chart.tag = {
        name: 'ss_total_signal_dropout_name',
      };
      chart.tooltip = {
        label: 'xs_reported_date_label',
        value: 'ss_total_signal_dropout_tooltip_value',
      };
      chart.legendDisabled = true;
      chart.dateFormatStr = 'LL';
      chart.formatDate = true;
      chart.hourSwitch = true;
    });

    patchChart(page.charts, 'ssSignalStrengthTS_w', (chart: LineChartConfig) => {
      chart.fullName = 'ss_avg_signal_strength_fullname';
      chart.name = 'ss_avg_signal_strength_name';
      chart.type = ChartTypeEnum.LINE;
      chart.elementType = 'chart';
      chart.layout = '100p';
      chart.dimension = {
        dimensionId: 'x',
        label: 'xs_time_interval_label',
        noDataLabel: 'no_data_label',
      };
      chart.metric = {
        metricId: 'ss',
        label: 'ss_avg_signal_strength_metric_label',
      };
      chart.tag = {
        name: 'Average Signal Strength',
      };
      chart.tooltip = {
        label: 'xs_reported_date_label',
        value: 'ss_avg_signal_strength_tooltip_value',
      };
      chart.legendDisabled = true;
      chart.formatDate = true;
      chart.allowNegativeValue = true;
      chart.dateFormatStr = 'LL';
      chart.hourSwitch = true;
    });

    patchChart(page.charts, 'ssTable_w', (chart: TableConfig) => {
      chart.name = 'Ticket_List_Devices_Header';
      chart.selectionType = InsSelectionType.multiple;
      chart.selectionText = 'device_selected_label';
      chart.selectionTextPlural = 'device_selected_label';
      chart.rowActions = [
        {
          action: 'customAttributes',
          tooltip: 'custom_attr_title',
          icon: 'insight-icon-deviceinfo',
        },
      ];
      chart.tableAttributes = [
        {
          id: 'McDeviceName',
          label: 'Column_Name_Device_Name',
          renderer: TableRenderEnum.LINK,
          iconClass: 'insight-icon-type-DeviceWindowsDesktop',
          rendererParams: {
            eventId: 'deviceClicked',
            icons: [
              {
                iconClass: 'insight-icon-type-DeviceWindowsDesktop',
              },
            ],
          },
        },
        {
          id: 'McDeviceId',
          label: 'Column_Name_Device_Id',
          renderer: TableRenderEnum.STRING,
        },
        {
          id: 'Name',
          label: 'Column_Name_Device_Group',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
        {
          id: 'McDevicePath',
          label: 'group_path_label',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
        {
          id: 'manufacturer',
          label: 'label_Manufacturer',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
        {
          id: 'model',
          label: 'Column_Name_Model',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
        {
          id: 'osVersion',
          label: 'Column_Name_Os_Version',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
        {
          id: 'carrier',
          label: 'networkcarrier_label',
          renderer: TableRenderEnum.STRING,
          iconClass: '',
        },
      ];
    });
  });

  const pageIds = [
    findPageId(app.pages, SIGNAL_STRENGTH_PAGE_W),
    // findPageId(devApp.pages, DEVICE_SUMMARY),
  ];

  const childPageIds = [
    findPageId(devAppWin.pages, DEVICE_BATTERY_USAGE_W),
    findPageId(devApp.pages, DEVICE_APP_USAGE),
    findPageId(devAppWin.pages, DEVICE_DATA_USAGE_W),
    findPageId(devApp.pages, DEVICE_LAST_KNOWN),
    findPageId(devAppWin.pages, DEVICE_SIGNAL_STRENGTH_W),
    findPageId(devApp.pages, SMART_BATTERY_SPOTLIGHT),
    findPageId(devApp.pages, DEVICE_WIFI),
  ];

  const defaultTabId = findPageId(devAppWin.pages, DEVICE_SIGNAL_STRENGTH_W);

  return { ...app, pageIds, childPageIds, defaultTabId };
}
